import MimiroVerticalIcon from './mimiro-vertical-icon';
export default MimiroVerticalIcon;
